module.exports = __webpack_public_path__ + "img/overlay-bg.e3da76c3.png";